// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__19Wu-","signatureButtonsRight":"ModalSign_signatureButtonsRight__1lbpJ"};